import { getBrandedTheme } from "./.themes";
export function getBrandedConfiguration(brand) {
    return {
        Theme: getBrandedTheme(brand),
    };
}
